import script from "./MenuBarFormLink.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBarFormLink.vue?vue&type=script&setup=true&lang=js"

import "./MenuBarFormLink.vue?vue&type=style&index=0&id=1a1cb412&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a1cb412"]])

export default __exports__